import React from 'react';
import { useParams } from 'react-router-dom';
import Loader from '@/components/common/Loader';
import useBulkImports from '@/lib/hooks/swr/useBulkImports';
import translate from '@/lib/intl/translate';
import type BulkImportParams from '../../types/BulkImportParams';
import BackToUploadsButton from './BackToUploadsButton';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import DataReviewSummary from './DataReviewSummary';

export default function DataReviewPage() {
  const { bulkImportId } = useParams<BulkImportParams>();
  const { data } = useBulkImports(bulkImportId);

  if (!data) {
    return <Loader isCentered />;
  }

  return (
    <div className="min-w-full p-4">
      <div className="flex flex-col gap-4">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="type-h1">{translate('DATA_UPLOADS_REVIEW')}</h1>
          <BackToUploadsButton />
        </div>
        <DataReviewSummary data={data?.[0]} />
      </div>
    </div>
  );
}
